<template>
  <div class="loader-container" id="loading-bg">
    <div class="svg-container">
      <DecastAnimatedLogo/>
    </div>
  </div>
</template>

<script>
import DecastAnimatedLogo from './DecastAnimatedLogo.vue';
export default {
  components: {
    DecastAnimatedLogo,
  },
}
</script>

<style>
#loading-bg {
  width: 100%;
  height: 100%; 
  background: #15161F;
  display: block;
  position: absolute;
  z-index: 9999;
  overflow: hidden; 
  top: 0;
  /* margin-top: -2rem;
  margin-left: -2rem; */
}

.svg-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10%;
  overflow: hidden;
}

.svg-container svg{
  height: 100px;
  width: 100px;
}

@media only screen and (max-width: 600px) {
  .svg-container {
    width: 25%;
  }
}
</style>